import React from 'react';
import { Lock, Undo2, ReceiptText, Landmark, ShieldCheck } from 'lucide-react';

// Each point is something the app really does (see the wallet ledger, refunds and the review queue).
const POINTS = [
  { icon: Lock, title: 'Secure payments by Razorpay', text: 'UPI, cards and net banking. Your card details go to Razorpay, never to us.' },
  { icon: Undo2, title: 'Unspent money comes back', text: 'Whatever your ad doesn’t spend returns to your wallet after it ends.' },
  { icon: ReceiptText, title: 'Every rupee shown', text: 'Ad spend, our 15% fee and GST on the fee, listed before you launch.' },
  { icon: Landmark, title: 'Withdraw anytime', text: 'Ask for your paid balance back to your original payment method.' },
  { icon: ShieldCheck, title: 'Checked before it runs', text: 'Every ad is checked against Meta’s rules, and we look at your first ad before it goes to Meta.' },
];

/**
 * Why customers can trust Rayogent with their money.
 * variant "full": a card with every point; "compact": short lines for dialogs and the launch step.
 */
export default function TrustPanel({ variant = 'full', className = '' }) {
  if (variant === 'compact') {
    return (
      <ul className={`space-y-1.5 text-xs ${className}`} data-testid="trust-compact">
        {POINTS.slice(0, 3).map(p => (
          <li key={p.title} className="flex items-start gap-2">
            <p.icon className="w-3.5 h-3.5 mt-0.5 shrink-0 text-money" aria-hidden="true" />
            <span><span className="font-semibold">{p.title}.</span> <span className="text-muted-foreground">{p.text}</span></span>
          </li>
        ))}
      </ul>
    );
  }
  return (
    <section className={`neo-card p-5 ${className}`} aria-labelledby="trust-title" data-testid="trust-panel">
      <h2 id="trust-title" className="text-lg font-extrabold font-heading mb-4">Your money is safe with us</h2>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {POINTS.map(p => (
          <li key={p.title} className="flex items-start gap-3">
            <span className="w-9 h-9 rounded-lg bg-money-soft border-2 border-ink flex items-center justify-center shrink-0">
              <p.icon className="w-4 h-4 text-money" aria-hidden="true" />
            </span>
            <span>
              <span className="block text-sm font-semibold">{p.title}</span>
              <span className="block text-xs text-muted-foreground leading-relaxed">{p.text}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
